import { useRouter } from 'next/router';
import { useEffect } from 'react';
// libs
import ReactPixel from 'react-facebook-pixel';

// core
import config from '@/core/config';
import env from '@/core/env';

const useFacebookPixel = () => {
    const router = useRouter();

    useEffect(() => {
        const pixelId = config.analytics.facebookPixelId;
        if (!pixelId) return;

        ReactPixel.init(pixelId, undefined, {
            autoConfig: true,
            debug: env.isDev,
        });
        ReactPixel.pageView(); // Track initial page load

        const handleRouteChange = () => {
            ReactPixel.pageView(); // Track subsequent page views
        };

        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    return null;
};

export default useFacebookPixel;
